<template>
  <div class="rightmenu">

    <div style="width: 120px;height: 290px">
      <el-image  :src="leftgg" style="width:inherit;height:inherit;border-radius: 10px 10px 10px 10px" fit="fill"></el-image>
    </div>
  </div>
</template>
<script>
import leftgg from '@@/assets/images/leftgg.jpg'

export default {
  computed: {
    leftgg() {
      return leftgg;
    }
  },
  data() {
    return {

    }
  },
  methods: {

  }
};
</script>
<style lang="less" scoped>

.rightmenu {
  width: 100px;
  position: fixed;
  left: 70px;
  bottom: 100px;
  align-items: flex-end;
}

</style>
